/* wle:auto-imports:start */
import {PlayerAnimationController} from './js/components/player-animation-controller.js';
import {WeaponSlot} from './js/components/weapon-slot.js';
/* wle:auto-imports:end */

export default function (engine) {
    /* wle:auto-register:start */
engine.registerComponent(PlayerAnimationController);
engine.registerComponent(WeaponSlot);
/* wle:auto-register:end */
}
